import _0xfd62f2 from'./getFreshSideObject.js';export default function mergePaddingObject(_0x18fa3a){return Object['assign']({},_0xfd62f2(),_0x18fa3a);}